import { Suspense, useEffect, useMemo, useState } from "react";
import { FreyrLibraryProvider } from "@freyr/freyr-react-common";
import { isExpired } from "react-jwt";
import { Outlet, useLocation } from "react-router-dom";
import cookie from "react-cookies";
import {
  ThemeProvider,
  createTheme,
  // useTheme
} from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import * as coreLocales from "@mui/material/locale";
import * as gridLocales from "@mui/x-data-grid/locales";
import * as pickersLocales from "@mui/x-date-pickers/locales";
import { apiGetDomains } from "../api/systemLibrary";
import { useGlobalData } from "../hooks/useGlobalData";
import { getURLDomain, logoutFunction } from "../common/utils";
import { LANGUAGEMAP, RIMS_COOKIE_CONSTANTS } from "../constants";
import useDomainStore from "../store/domain";
import { useConfigStore } from "../store/config";
import SideMenu from "../component/SideMenu";
import "../assets/scss/page/index.scss";
import { useUrfReceiveEvents } from "../hooks/urfEvents";

type SupportedLocales = keyof typeof coreLocales;
type GridLocales = keyof typeof gridLocales;
type PickersLocales = keyof typeof pickersLocales;

const Layouts = () => {
  const [auth, setAuth] = useState<boolean>(false);
  const { token, tenant, domain } = useGlobalData();
  const { language } = useConfigStore();
  const URLDomain = getURLDomain();
  const redirectURL = `https://portal.${URLDomain}`;
  const { updateDomain, domainValue } = useDomainStore();
  const location = useLocation();
  const isBpmnRoute = location.pathname.startsWith("/bpmn");
  const themeWithLocale = useMemo(() => {
    const locale: SupportedLocales = LANGUAGEMAP.mui[language];
    const gridLocale: GridLocales = LANGUAGEMAP.mui[language];
    const pickersLocale: PickersLocales = LANGUAGEMAP.mui[language];
    return createTheme(
      {
        palette: {},
      },
      coreLocales[locale],
      gridLocales[gridLocale],
      pickersLocales[pickersLocale]
    );
  }, [language]);

  useUrfReceiveEvents();

  useEffect(() => {
    let blLogin = token;
    if (blLogin === null || isExpired(blLogin)) {
      logoutFunction();
      window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
    } else {
      setAuth(true);
    }
  }, [redirectURL, token]);

  useEffect(() => {
    // getDomainID
    apiGetDomains().then((res) => {
        const result = res?.data;
        if (Array.isArray(result) && result.length > 0) {
          const curDomainLabel = cookie.load(RIMS_COOKIE_CONSTANTS.DOMAIN);
        const curDomain = result.find((o) => o.domainPhrase === curDomainLabel);
          if (curDomain) {
            updateDomain({
              domainName: curDomain?.domainPhrase,
              domainId: curDomain?.value,
            });
          }
        }
    },() => {});
  }, []);

  // const iframeWidth = window.innerWidth;
  // document.documentElement.style.setProperty(
  //   "--iframe--width",
  //   `${iframeWidth}px`
  // );

  return (
    <>
      {auth && (isBpmnRoute || !!domainValue?.domainId) && (
        <ThemeProvider theme={themeWithLocale}>
          <FreyrLibraryProvider
            token={token}
            language={language}
            tenant={isBpmnRoute ? (cookie.load(RIMS_COOKIE_CONSTANTS.AC_TENANT_ID) || tenant) : tenant}
            domain={domainValue.domainId}
            domainName={domainValue.domainName}
          >
            <Box className="custom-page" data-testid={"custom-page"}>
                <Suspense>
                  <Outlet />
                </Suspense>
            </Box>
          </FreyrLibraryProvider>
        </ThemeProvider>
      )}
    </>
  );
};

export default Layouts;
